enum GaEventEnum {
	savePlanner = 'save_planner',
	addToWishlist = 'add_to_wishlist',
	addToCart = 'add_to_cart',
	openPlanner = 'open_planner'
}

export default GaEventEnum;
